import Scrolling from '../utils/class/scrolling';

const QUERIES = {
    popup: '.site-popup',
    toggle: '.site-popup-toggle',
    close: '.site-popup-close',
    window: '.site-popup-window'
}

/**
 * This feature is used to set popup behavior
 * 
 * @class Popup
 * @param {Object} [queries]
 */

export default class Popup {
    constructor (queries = QUERIES) {
        const popup = queries.popup ? document.querySelector(queries.popup) : document.querySelector(QUERIES.popup);
        if (!popup) throw new Error('Popup not found');

        const toggle = queries.toggle ? document.querySelector(queries.toggle) : document.querySelector(QUERIES.toggle);
        const close = queries.close ? document.querySelector(queries.close) : document.querySelector(QUERIES.close);
        const inner = queries.window ? document.querySelector(queries.window) : document.querySelector(QUERIES.window);

        this.popup = popup;
        this.toggle = toggle || null;
        this.close = close || null;
        this.inner = inner || null;
        this.scrolling = new Scrolling();

        this.init();
    }

    init () {
        window.addEventListener('click', (event) => {
            event.stopPropagation();

            this.handleClose();
        });

        if (this.toggle) {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleOpen();
            });
        }

        if (this.inner) {
            this.inner.addEventListener('click', (event) => {
                event.stopPropagation();
                
                this.handleOpen();
            });
        }

        if (this.close) {
            this.close.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleClose();
            });
        }
    }

    handleOpen () {
        this.popup.classList.add('opened');

        this.scrolling.disable();
    }

    handleClose () {
        this.popup.classList.remove('opened');

        this.scrolling.enable();
    }

    open () {
        this.handleOpen();
    }

    close () {
        this.handleClose();
    }
}

/**
 * Usage example
 * 
 * import Popup from 'components/popup';
 * 
 * new Popup({
 *  popup: '.site-popup[data-popup=popup]',
 *  toggle: '.site-popup-toggle[data-popup=popup]',
 *  close: '.site-popup-close[data-popup=popup]',
 *  window: '.site-popup-window[data-popup=popup]'
 * });
 * 
 * OR
 * 
 * new Popup({
 *  popup: '.site-popup[data-popup=popup]',
 *  close: '.site-popup-close[data-popup=popup]'
 * }).open();
 * 
 */
